import { render } from "./Ranking.vue?vue&type=template&id=2d7bef45"
import script from "./Ranking.vue?vue&type=script&lang=js"
export * from "./Ranking.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/society/kingdomIn/Ranking.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2d7bef45"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2d7bef45', __exports__)) {
    api.reload('2d7bef45', __exports__)
  }
  
  module.hot.accept("./Ranking.vue?vue&type=template&id=2d7bef45", () => {
    api.rerender('2d7bef45', render)
  })

}


export default __exports__